// extracted by mini-css-extract-plugin
export default {"error":"_3fdxh","success":"_3mTFQ"};